import { api } from '../../lib'
import { Loading } from '../../app/ui'
import { Err, GrantCopy, PartnerPage, PRICE_COPY, SetupFooter, useAction, useSetup } from './common'

export function BillingPage() {
  return <PartnerPage>{(pid, role) => <BillingBody pid={pid} canEdit={role !== 'viewer'} />}</PartnerPage>
}

function BillingBody({ pid, canEdit }: { pid: string; canEdit: boolean }) {
  const s = useSetup(pid)
  const setup = useAction(
    (collection: 'ach_debit' | 'send_invoice') =>
      api<{ url: string | null }>('POST', `/api/partners/${pid}/billing/setup`, { collection }),
    (r) => {
      if (r.url) window.location.assign(r.url)
    },
  )
  if (!s.data) return s.error ? <Err error={s.error} /> : <Loading />
  const b = s.data.billing
  return (
    <div className="page narrow stack">
      <h1>Billing</h1>
      <section className="panel stack" data-testid="partners-billing-copy">
        <p>{PRICE_COPY}</p>
        <GrantCopy grant={s.data.grant} />
      </section>
      <section className="panel stack">
        <h2>How you pay</h2>
        {b.ready && (
          <p data-testid="partners-billing-ready">
            {b.collection === 'ach_debit' ? 'We take each bill from your bank.' : 'We email each bill. Pay from the link in it, from your bank account or by wire.'} Bills are due in{' '}
            {b.net_days} days.
          </p>
        )}
        {b.bank_setup === 'waiting' && (
          <p className="muted" data-testid="partners-billing-waiting">
            Waiting for your bank to confirm. Stripe emailed you how.
          </p>
        )}
        {b.bank_setup === 'failed' && (
          <p className="negative" data-testid="partners-billing-failed">
            Your bank was not confirmed. Connect it again, or choose emailed bills.
          </p>
        )}
        {!b.ready && !b.bank_setup && <p className="muted" data-testid="partners-billing-none">No bank connected yet.</p>}
        {b.releases_blocked && (
          <p className="negative" data-testid="partners-releases-blocked">
            A payment was returned. Customers' points stay on hold until that bill is paid.
          </p>
        )}
        {canEdit && (
          <div className="row">
            <button className="primary" data-testid="partners-billing-setup" disabled={setup.busy} onClick={() => setup.run('ach_debit')}>
              {b.ready && b.collection === 'ach_debit' ? 'Change bank' : 'Connect your bank'}
            </button>
            <button data-testid="partners-billing-invoice" disabled={setup.busy} onClick={() => setup.run('send_invoice')}>
              Email me bills instead
            </button>
          </div>
        )}
        <Err error={setup.error} />
      </section>
      <SetupFooter pid={pid} step="billing" />
    </div>
  )
}
